import BpkMultiSelectChipGroup, {
  CHIP_GROUP_TYPES,
} from '@skyscanner/backpack-web/bpk-component-chip-group';

import type { OnApplyFilter } from '@hotels-hotel-detail/data-access/types/hotel-reviews';
import type { FilterGroup } from '@shared/types/frontend/ubff/hotel-reviews';
import type { I18nService } from '@shared/types/i18n';

import { useSelectedTag } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  tagGroup: FilterGroup;
  disabled?: boolean;
  isMobile?: boolean;
  applyFilter: OnApplyFilter;
};

const FilterWithTagsGroup = ({
  applyFilter,
  disabled,
  i18n,
  isMobile,
  tagGroup,
}: Props) => {
  const { filters: tagOptions, type } = tagGroup;
  const selectedTag = useSelectedTag();

  const label = i18n.translate('Reviews_MentionedByTravellers');

  const chipItems = tagOptions.map(({ displayText, value }) => ({
    onClick: (isSelected: boolean, _chipIndex: number) =>
      applyFilter({ type, value: isSelected ? value : '' }),
    selected: value === selectedTag,
    text: displayText,
    disabled,
  }));

  return (
    <BpkMultiSelectChipGroup
      type={CHIP_GROUP_TYPES.rail}
      chips={chipItems}
      label={isMobile ? undefined : label}
      ariaLabel={label}
      leadingNudgerLabel={i18n.translate(
        'Offer_filters_chip_group_leading_nudger_label',
      )}
      trailingNudgerLabel={i18n.translate(
        'Offer_filters_chip_group_trailing_nudger_label',
      )}
    />
  );
};

export default withI18n(FilterWithTagsGroup);
